import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const noop = async () => { };

const AnchorContext = createContext({
    anchors: [],
    current: null,
    setAnchors: noop,
    setCurrent: noop
});

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */
/**
 * @function useAnchor
 * useAnchor hook, stores modal DOM node and modal state
 */
const useAnchor = () => {
    const context = useContext(AnchorContext);

    if (context === undefined) {
        throw new Error('useLocale must be used within a LocaleProvider.');
    }

    return context;
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component ModalProvider
 * @props (see propTypes)
 */
const AnchorProvider = ({ children }) => {
    const [anchors, setAnchors] = useState([]);
    const [current, setCurrent] = useState(null);

    return (
        <AnchorContext.Provider value={useMemo(() => {
            return {
                anchors,
                current,
                setAnchors,
                setCurrent,
            };
        }, [
            anchors,
            current,
            setCurrent,
            setAnchors,
        ])}>
            {children}
        </AnchorContext.Provider>
    );
};

AnchorProvider.propTypes = {
    children: PropTypes.any,
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export {
    AnchorProvider,
    useAnchor
};
